import React from 'react'

function BulkLocationEditorJobResults({jobResults, locations}) {
  return <div>
    <div className="card-spacer-bottom">Job ID {jobResults._id["$oid"]}{" "}: {jobResults.status}</div>
    <table style={{"width": "100%"}}>
      <tbody>
    {(jobResults.locationIds || []).map((locationId, index) => {
      const maybeLocation = locations[locationId];
      const locationLabel = maybeLocation && maybeLocation.name ? maybeLocation.name : locationId;
      return <tr key={"processing-" + index}>
        <td>{locationLabel}<br />{locationId}</td>
        <td style={{"minWidth": "300px"}}>
          <div className="progress">
            <div className="progress-bar progress-bar-striped bg-warning progress-bar-animated" role="progressbar"
  aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{"width": "33%"}} />
          </div>
        </td>
      </tr>
    })}
    {jobResults.failedLocationIdsAndErrors.length > 0 && <div className="card-spacer-top"/>}
    {(jobResults.failedLocationIdsAndErrors || []).map((locationIdAndError, index) => {
      const locationId = locationIdAndError.locationId;
      const error = locationIdAndError.error;
      const maybeLocation = locations[locationId];
      const locationLabel = maybeLocation && maybeLocation.name ? maybeLocation.name : locationId;
      return <tr key={"processed-" + index}>
        <td>{locationLabel}<br />{locationId}</td>
        <td style={{"minWidth": "300px"}}>
          <div className="progress">
            <div className="progress-bar progress-bar-striped bg-danger" role="progressbar"
                 aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{"width": "100%"}} />
          </div>
          <div className="invalid-feedback" style={{"display": "block", "wordWrap": "break-all"}}>
            {error}
          </div>
        </td>
      </tr>
    })}
    {jobResults.processedLocationIds.length > 0 && <div className="card-spacer-top"/>}
    {(jobResults.processedLocationIds || []).map((locationId, index) => {
      const maybeLocation = locations[locationId];
      const locationLabel = maybeLocation && maybeLocation.name ? maybeLocation.name : locationId;
      return <tr key={"processed-" + index}>
        <td>{locationLabel}<br />{locationId}</td>
        <td style={{"minWidth": "300px"}}>
          <div className="progress">
            <div className="progress-bar progress-bar-striped bg-success" role="progressbar"
                 aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{"width": "100%"}} />
          </div>
        </td>
      </tr>
    })}
      </tbody>
    </table>
  </div>
}

export default BulkLocationEditorJobResults